import React from 'react';
import {
  useParams
} from 'react-router';
import PAGES from 'common/pages';
import Progress from 'components/Progress/Progress';
import { makeStyles } from '@mui/styles';
import SwitchLeftView from './SwitchLeftView';

const drawerWidth = 320;
const useStyles = makeStyles(() => ({
  rightComponent: {
    minWidth: 1000,
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth})px`
  }
}));

const SwitchContainer = ({ rightComponent }) => {
  const { id } = useParams();
  const classes = useStyles();

  const config = {
    pageName: 'Switches',
    templates: {
      key: (dataItem) => dataItem.id,
      primaryText: (dataItem) => dataItem.name,
      secondaryText: () => { },
      pageLink: (dataItem) => `${PAGES.SWITCHES}/${dataItem.id}`,
    },
    isSelectedRow: (dataItem) => dataItem.id === id,
    rightComponent
  };

  if (id) {
    return (
      <>
        <SwitchLeftView config={config} />
        <div className={classes.rightComponent}>
          {rightComponent}
        </div>
      </>
    );
  }

  return <Progress />;
};

export default SwitchContainer;
